import { Resolve } from "@angular/router";
import { Injectable } from "@angular/core";
import { Keys, StorageService } from "../service/storage.service";
import { LenderAccountInfo } from "../model/finzy-flex/lender-account.model";
import { AccountService } from "../service/finzy-flex/account/account.service";

@Injectable()
export class LenderAccountInfoResolver implements Resolve<LenderAccountInfo | null> {
    private readonly accountService: AccountService;
    private readonly storageService: StorageService;

    constructor(accountService: AccountService, storageService: StorageService) {
        this.accountService = accountService;
        this.storageService = storageService;
    }

    public async resolve(): Promise<LenderAccountInfo | null> {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const lenderAccountInfo = this.accountService.getLenderAccountInfo(lenderId);
        return lenderAccountInfo ? lenderAccountInfo : null;
    }
}
